import TableMQConfigAlerts from "./TableMQConfigAlerts";
import TableMQ24GConfigAlerts from "./TableMQ24GConfigAlerts";

const ManagerDataTable = ({item, _TC}) => {
    switch (item.model) {
        case "MQ-SX":
            return <TableMQConfigAlerts item={item} _TC={_TC} />;
        case "MQ2-4G":
            return <TableMQ24GConfigAlerts item={item} _TC={_TC} />;
        default:
            return <></>;
    }
};
export default ManagerDataTable;
